import styled from 'styled-components'
import { sureco } from '../shared/finance.styles'

export const SplitCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 14px;
  border: 1px solid ${sureco.border};
  border-radius: 8px;
  background: ${sureco.pageBg};

  .ant-picker,
  .ant-input-number {
    width: 100%;
  }
`

export const SplitTitle = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: ${sureco.fg2};
`

export const SplitPart = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const SplitPartLabel = styled.label`
  font-size: 12px;
  font-weight: 500;
  color: ${sureco.fg3};
`

export const SplitRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
`

export const SplitActions = styled.div`
  display: flex;
  justify-content: flex-end;
`

export const SplitHint = styled.div<{ $tone?: 'warning' }>`
  font-size: 12px;
  line-height: 1.4;
  color: ${({ $tone }) => ($tone === 'warning' ? '#b45309' : sureco.fg3)};
`
